import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { getPresentation } from '@/api/presentations/presentations'
import { useProjectBreadcrumb } from '@/common/useProjectBreadcrumb'
import { PageHeader } from '@/components/PageHeader'
import { PresentationWorkspace } from '@/components/presentation/PresentationWorkspace'

const searchSchema = z.object({ autobuild: z.boolean().optional() })

export const Route = createFileRoute('/_auth/$orgSlug/$projectId/presentation-agent/$presentationId/')({
  validateSearch: searchSchema,
  loader: ({ params }) => getPresentation(Number(params.projectId), Number(params.presentationId)),
  head: () => ({ meta: [{ title: 'Presentation Agent - Snowvault' }] }),
  component: PresentationAgentWorkspace
})

function PresentationAgentWorkspace() {
  const presentation = Route.useLoaderData()
  const { orgSlug } = Route.useParams()
  const { autobuild } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { projectTitle, projectTo } = useProjectBreadcrumb()
  return (
    <>
      <PageHeader
        breadcrumbs={[
          { label: projectTitle, to: projectTo },
          { label: 'Presentation Agent' },
          { label: presentation.title }
        ]}
      />
      <PresentationWorkspace
        orgSlug={orgSlug}
        initialPresentation={presentation}
        autobuild={autobuild ?? false}
        onAutobuildConsumed={() => navigate({ search: {}, replace: true })}
      />
    </>
  )
}
